import { UseFormWatch } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';

type UseHoldingClassFieldsProps = {
  index: number;
  watch: UseFormWatch<rules.CreateRealisationFormValues>;
};

const useHoldingClassFields = ({
  index,
  watch,
}: UseHoldingClassFieldsProps) => {
  const unitsSoldFieldName =
    `holdingClassRealisation.${index}.unitsSold` as const;

  const selectedPartialRealisationAllocationLogicFieldName =
    `holdingClassRealisation.${index}.partialRealisationAllocationLogic` as const;

  const selectedHoldingClassId = watch(
    `holdingClassRealisation.${index}.holdingClassId`,
  );

  const selectedPartialRealisationAllocationLogic = watch(
    selectedPartialRealisationAllocationLogicFieldName,
  );

  const unitsSold = watch(unitsSoldFieldName);

  return {
    unitsSoldFieldName,
    selectedPartialRealisationAllocationLogicFieldName,
    selectedHoldingClassId,
    selectedPartialRealisationAllocationLogic,
    unitsSold,
  };
};

export default useHoldingClassFields;
